import { TWarboxMessageInitialState } from '../types';

export const DEFAULT_WARBOX_MESSAGE_STATE: TWarboxMessageInitialState = {
    messages: null,
    total: 0,
    loading: false,
    galleryMessages: null,
    galleryTotal: 0,
    galleryLoading: false,
    error: null,
    success: null,
};
